import Box from '@mui/material/Box';
import { AudiencesTable } from './sections/Audiences/AudiencesTable';
import { DeliveryByAdDurationTable } from './sections/DeliveryByAdDurationTable/DeliveryByAdDurationTable';
import { DeliveryByAdSizeTable } from './sections/DeliveryByAdSizeTable/DeliveryByAdSizeTable';
import { DeliveryByDomainBundleTable } from './sections/DeliveryByDomainBundleTable/DeliveryByDomainBundleTable';

export const DealInsightsDelivery = () => {
  return (
    <Box component="section" data-test="deal-insights-delivery">
      <DeliveryByDomainBundleTable />
      <DeliveryByAdSizeTable />
      <DeliveryByAdDurationTable />
      <AudiencesTable />
    </Box>
  );
};
